export default __webpack_public_path__ + "static/header_background-a87c5ed2881dca99432c05b6897ff3eb.png";